import { environment } from '@uw-env/environment';

export const DEFAULT_OPTION: string = "DEFAULT_OPTION";

export const UWGT: number = 2;

export const SsoProviderTypesConfig = [
  { key: 'oneLogin', value: { logoSrc: 'assets/images/onelogin-logo.png', name: 'OneLogin' }},
  { key: 'okta', value: { logoSrc: 'assets/images/okta-logo.png', name: 'OKTA' }},
  { key: 'auth0', value: { logoSrc: 'assets/images/auth0-logo.png', name: 'Auth0' }},
  { key: 'google', value: { logoSrc: 'assets/images/google-logo.png', name: 'Google' }},
  { key: 'azure', value: { logoSrc: 'assets/images/entraid-logo.png', name: 'Entra ID' }},
  { key: 'cognito', value: { logoSrc: 'assets/images/cognito-logo.png', name: 'Cognito' }},
  { key: 'miniOrange', value: { logoSrc: 'assets/images/miniorange-logo.png', name: 'MiniOrange' }},
  { key: 'frontegg', value: { logoSrc: 'assets/images/frontegg-logo.png', name: 'Frontegg' }},
  { key: 'pingIdentity', value: { logoSrc: 'assets/images/pingidentity-logo.png', name: 'PingIdentity' }},
  { key: 'workOS', value: { logoSrc: 'assets/images/workos-logo.png', name: 'WorkOS' }},
  { key: 'secureAuth', value: { logoSrc: 'assets/images/secureauth-logo.png', name: 'SecureAuth' }},
  { key: 'other', value: { logoSrc: 'assets/images/sso-default-logo.png', name: 'Other' }},
];

export const TimeZoneMap: {[key: string]: string} = {
  'EST': 'America/Toronto',
  'EDT': 'America/Toronto',
  'CST': 'America/Winnipeg',
  'CDT': 'America/Winnipeg',
  'MBT': 'Etc/GMT+5',
  'SKT': 'America/Regina',
  'MDT': 'America/Edmonton',
  'PDT': 'America/Vancouver',
  // Alberta, BC and Manitoba stay on daylight time all year, so they use fixed UTC offsets
  // instead of the browser's time zone data (which may still switch them to standard time).
  'MST': 'Etc/GMT+6',
  'PST': 'Etc/GMT+7',
  'ADT': 'America/Halifax',
  'AST': 'America/Halifax'
}

// Header label for zones whose fixed-offset zone name would otherwise show as "GMT-7" etc.
export const TimeZoneLabelMap: {[key: string]: string} = {
  'MST': 'MDT',
  'PST': 'PDT',
  'MBT': 'CDT',
  'SKT': 'CST'
}

export enum FileType {
  EMPLOYEE = 'employee',
  MERGE = 'merge',
  OFFLINE_DONATION = 'offlinedonation',
  GIVING_HISTORY = 'givinghistory',
  CATALOG = 'catalog',
  CATALOG_SET = 'catalogset',
  EMPLOYEE_CATALOG_SET = 'employeecatalogset',
  MASS_DISABLE= 'massdisable'
}

export const SampleFileNamesMap = {
  [FileType.EMPLOYEE]: `${environment.fileDownloadBaseUrl}/Employee_SampleFile.xlsx`,
  [FileType.MERGE]: `${environment.fileDownloadBaseUrl}/Merge_SampleFile.xlsx`,
  [FileType.OFFLINE_DONATION]: `${environment.fileDownloadBaseUrl}/OffilineDonation_SampleFile.xlsx`,
  [FileType.GIVING_HISTORY]: `${environment.fileDownloadBaseUrl}/GivingHistory_SampleFile.xlsx`,
  [FileType.CATALOG]: `${environment.fileDownloadBaseUrl}/AgencyCatalogue_SampleFile.xlsx`,
  [FileType.CATALOG_SET]: `${environment.fileDownloadBaseUrl}/ServicingUnitedway_SampleFile.xlsx`,
  [FileType.EMPLOYEE_CATALOG_SET]: `${environment.fileDownloadBaseUrl}/DonorServicing_SampleFile.xlsx`,
  [FileType.MASS_DISABLE]: `${environment.fileDownloadBaseUrl}/MassDisable_SampleFile.xlsx`,
}